// AUTO-GENERATED — do not edit by hand.
// Written by scripts/sync-version.mjs from the "version" field in package.json.
// Run `pnpm version <patch|minor|major>` to bump; the version hook regenerates this file
// and syncs the native iOS/Android build files via Trapeze.
export const appVersion = "2.6.0";
